export function findErrorDetail(obj) {
  if (obj == null) return null;

  if (typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, 'detail')) {
    return obj.detail;
  }

  if (Array.isArray(obj)) {
    return obj.reduce((found, item) => {
      return found ?? findErrorDetail(item);
    }, null);
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).reduce((found, key) => {
      return found ?? findErrorDetail(obj[key]);
    }, null);
  }

  return null;
}
